export function getTranslation(data) {
    const languageCode = "en";

    if (!data) {
        return "";
    }

    if(typeof data === "string"){
        return data;
    }

    if (data && data[languageCode]) {
        return data[languageCode];
    }

    console.error("unable to get translation for", data);
    return "";
}